import React from 'react';
import classNames from 'classnames';
import { Card, CardHeader, CardBody } from 'shards-react';

const DivaPage = (props) => {
    const { id, thumbnail, setPageToDisplay, isSelected, toggleSelection, divaPgNum } = props;

    const borderColor = `border-${isSelected ? 'success' : 'transparent'}`;

    const classes = classNames('border-2', borderColor, 'mr-1', 'mb-1', 'w-100', 'dnd-page');

    const preventMiddleClick = (e) =>
        e.button === 1 ? (e.preventDefault(), e.target.focus()) : null;

    // Using onClick as it will be correctly
    // preventing if there was a drag
    const clickHandler = (e) => {
        if (e.defaultPrevented) return;
        if (e.button !== 0) return;
        // marking the event as used
        e.preventDefault();

        performAction(e);
    };

    const performAction = (e) => {
        setPageToDisplay({ actual: id });
        toggleSelection({ pageId: id, columnId: 'diva'})
    };

    const previewPage = () => {
        return setPageToDisplay((oldState) => {
            if (oldState.actual === id) return oldState;

            return {
                ...oldState,
                preview: id,
            };
        });
    };

    const leavePage = () =>
        setPageToDisplay((oldState) => {
            if ('preview' in oldState) return { actual: oldState.actual };
            return oldState;
        });

    return (
        <Card
            className={classes}
            onClick={clickHandler}
            onMouseDown={preventMiddleClick}
            style={{cursor: 'pointer'}}
        >
            <CardHeader className='p-0 d-flex'>
                <span className='font-italic mx-auto'>{`DiVA Seite: ${
                    divaPgNum
                }`}</span>
            </CardHeader>
            <CardBody className='p-0 text-center'>
                <img
                    onMouseEnter={previewPage}
                    onMouseLeave={leavePage}
                    className='rounded w-100'
                    alt={`thumbnail-${divaPgNum}`}
                    src={thumbnail}
                    width='200'
                    height='282'
                />
            </CardBody>
        </Card>
    );
};

export default DivaPage;
